import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { t, jt } from 'ttag';
import classNames from 'classnames';

// import PenIcon from '@svg/pen.svg';
import ArrowRightIcon from '@svg/arrows-right.svg';
import BookmarkIcon from '@svg/bookmark.svg';
import ThumbsUpIcon from '@svg/thumbs-up.svg';
import {
  memberSocialPosts,
  memberSocialPostsLiked,
  memberSocialPostsSaved,
  // socialAddPost,
} from '@urls';
import { TabBar } from '@ui/TabBar';
import { Tab } from '@ui/Tab';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
// import { CreateSocialPostButton } from '@components/CreateSocialPostButton';

import s from './ProfileSocialPostsAside.sss';

interface Props {
  className?: string,
  username: string,
  postsAmount?: number,
  isSelfProfile: boolean,
}

export const ProfileSocialPostsAside: React.FC<Props> = ({
  className,
  username,
  postsAmount,
  isSelfProfile,
}) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(true);
  const [isSavedLinksOpen, setIsSavedLinksOpen] = useState(isSelfProfile);

  const postsAmountText = (
    <span
      key={0}
      className={s.count}
    >
      {postsAmount}
    </span>
  );

  return (
    <>
      <div className={className}>
        <Title
          className={s.title}
          type='h3'
          bold={false}
        >
          {t`Огляди`}
        </Title>

        {/* {isSelfProfile && (
          <Button
            className={s.addSocialButtonDesktop}
            to={socialAddPost}
          >
            <PenIcon
              width="24"
              height="24"
            />
            {t`Створити пост`}
          </Button>
        )} */}

        <section className={s.section}>
          <Button
            className={s.subTitle}
            theme='text'
            onClick={() => setIsFiltersOpen((prevState) => !prevState)}
          >
            {t`Фільтр`}

            <ArrowRightIcon
              className={classNames(s.arrowIcon, {
                [s.arrowIconStateOpen]: isFiltersOpen,
              })}
              width="24"
              height="24"
            />
          </Button>

          {isFiltersOpen && (
            <TabBar className={s.tabBar}>
              <Tab
                className={s.tab}
                exact={true}
                to={generatePath(memberSocialPosts, { username })}
              >
                {jt`Всі пости ${postsAmountText}`}
              </Tab>
            </TabBar>
          )}
        </section>

        {isSelfProfile && (
          <section className={s.section}>
            <Button
              className={s.subTitle}
              theme='text'
              onClick={() => setIsSavedLinksOpen((prevState) => !prevState)}
            >
              {t`Збереження`}

              <ArrowRightIcon
                className={classNames(s.arrowIcon, {
                  [s.arrowIconStateOpen]: isSavedLinksOpen,
                })}
                width="24"
                height="24"
              />
            </Button>

            {isSavedLinksOpen && (
              <TabBar className={s.tabBar}>
                <Tab
                  className={s.tab}
                  exact={true}
                  to={generatePath(memberSocialPostsSaved, { username })}
                >
                  <BookmarkIcon
                    className={s.icon}
                    width='24'
                    height='24'
                  />
                  {t`Обрані`}
                </Tab>
                <Tab
                  className={s.tab}
                  exact={true}
                  to={generatePath(memberSocialPostsLiked, { username })}
                >
                  <ThumbsUpIcon
                    className={s.icon}
                    width='24'
                    height='24'
                  />
                  {t`Лайк`}
                </Tab>
              </TabBar>
            )}
          </section>
        )}
      </div>

      {/* {isSelfProfile && (
        <CreateSocialPostButton
          className={s.addSocialButtonMobile}
          isIconType={true}
        />
      )} */}
    </>
  );
};
